// import React, { useState } from 'react';
// import './Subscription.css';

// const Subscription = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const freeTier = {
//     title: "Free Tier",
//     price: "Free",
//     features: [
//       { text: "3 pro searches per day", available: true },
//       { text: "Limited fact-checking sources", available: true },
//       { text: "20 minutes of Video fact-checks per day", available: true },
//     ],
//   };

//   const proTier = {
//     title: "Pro Tier",
//     price: "$9.99/month",
//     features: [
//       { text: "Unlimited pro searches", available: true },
//       { text: "Access to detailed fact-checking sources", available: true },
//       { text: "3 hours of Video fact-checks per day", available: true },
//     ],
//   };

//   const renderFeatures = (features) => (
//     <ul className="feature-list">
//       {features.map((feature, index) => (
//         <li key={index} className="feature-item">
//           <span className={`feature-icon ${feature.available ? 'available' : 'unavailable'}`}>
//             {feature.available ? '✓' : '✗'}
//           </span>
//           {feature.text}
//         </li>
//       ))}
//     </ul>
//   );

//   const handleSubscribeClick = () => {
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="subscription-container">
//       <h1 className="page-title">Choose Your Facticity.AI Plan</h1>

//       <div className="plans-wrapper">
//         {/* Free Tier */}
//         <div className="plan-card free-tier">
//           <h2 className="plan-title">{freeTier.title}</h2>
//           <p className="plan-price">{freeTier.price}</p>
//           {renderFeatures(freeTier.features)}
//           <button className="plan-button free-button">
//             Current Plan
//           </button>
//         </div>

//         {/* Pro Tier */}
//         <div className="plan-card pro-tier">
//           <h2 className="plan-title">{proTier.title}</h2>
//           <p className="plan-price">{proTier.price}</p>
//           {renderFeatures(proTier.features)}
//           <button
//             className="plan-button pro-button"
//             onClick={handleSubscribeClick}
//           >
//             Coming Soon
//           </button>
//         </div>
//       </div>

//       {/* Modal */}
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3 className="modal-title">Coming Soon</h3>
//             <p className="modal-text">
//               Our payment gateway is currently being integrated and will be available soon.
//             </p>
//             <p className="modal-subtext">
//               Stay tuned! In the meantime, enjoy your Pro Subscription Free Trial.
//             </p>
//             <button
//               className="modal-close-button"
//               onClick={handleCloseModal}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Subscription;

import React, { useState, useEffect  } from 'react';
import './Subscription.css';
import { useNavigate } from 'react-router-dom';
// Material-UI Components and Hooks
import { IconButton, Grid, Box, useTheme, useMediaQuery, Button, } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
// Material-UI Icons
import MenuIcon from '@mui/icons-material/Menu';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { Link } from '@mui/material';


// Authentication and Context
import { useAuth0 } from '@auth0/auth0-react';
import { useAppContext } from './AppProvider';

// Custom Components
import Sidebar from './components/Sidebar';
import ThirdColumn from './components/ThirdColumn';
const Subscription = () => {
  // Authentication
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isProUser, setIsProUser] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success or error

  const {
    isSidebarOpen,
    toggleSidebar,
    handleCloseSidebar,
    setIsSearchMoved,
    createConversation,
    backendUrl
  } = useAppContext();

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      if (isAuthenticated && user?.email) {
        try {
          const token = await getAccessTokenSilently();
          const response = await fetch(`${backendUrl}/get_user_subscription_by_email`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email: user.email }),
          });

          if (response.ok) {
            const data = await response.json();
            if (data.subscriptions && data.subscriptions.some(sub => sub.status === "active" || sub.status === "trialing")) {
              setIsProUser(true);
            } else {
              setIsProUser(false);
            }
          } else {
            console.error("Failed to fetch subscription status:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching subscription status:", error);
        }
      }
    };

    fetchSubscriptionStatus();
  }, [isAuthenticated, user, getAccessTokenSilently]);
  
  const navigate = useNavigate();
  // App Context (Assuming you have an AppProvider that provides these)


  // Responsive Design
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Define Subscription Tiers
  const freeTier = {
    title: "Basic",
    price: "$0/month",
    description: "Ideal for individuals who want to verify claims",
    features: [
      { text: "35 credits (7 fact-checks) renew daily", available: true },
      { text: "Fact check against web sources (includes summary, truth label, explanation, sources, disambiguation, bias)", available: true },
      { text: "Long query check (more than 250 characters - Factual content is broken into claims and checked one by one)", available: true },
      { text: "Video fact checks (YouTube, TikTok, Instagram reels links - Factual content is broken into claims and checked one by one)", available: true },
      { text: (
        <>
          <Link href="https://app.facticity.ai/api" target="_blank" rel="noopener noreferrer">
            API access
          </Link> 
          {" (100 Facticity AI tokens)"}
        </>
      ), available: true },
      ,
    ],
  };

  const proTier = {
    title: "Essential",
    price: "$9.99/month",
    description: "Ideal for professionals who need higher usage and more tools to ensure accuracy",
    features: [
      { text: "5000 credits (1000 checks) renew daily", available: true },
      { text: "Fact check against web sources only (includes summary, truth label, explanation, sources, disambiguation, bias)", available: true },
      { text: "Long query check (more than 250 characters - Factual content is broken into claims and checked one by one)", available: true },
      { text: "Video fact checks (YouTube, TikTok, Instagram reels links - Factual content is broken into claims and checked one by one)", available: true },
      { text: (
        <>
          <Link href="https://app.facticity.ai/api" target="_blank" rel="noopener noreferrer">
            API access
          </Link> 
          {" (100 Facticity AI tokens)"}
        </>
      ), available: true },
      { text: "Early access to new features", available: true },
      ,
    ],
  };

  const entTier = {
    title: "Enterprise",
    price: "Custom",
    description: "Ideal for organizations with custom fact-checking workflows or integration. (Features listed below for Enterprise are under development, subject to change based on client feedback)",
    features: [
      { text: "Everything in Essential", available: true },
      { text: "Custom Integration & API access", available: true },
      { text: "Unlimited Data Integration", available: true },
      { text: "CMS Integration - WordPress", available: true },
      { text: "Brand Protection Bot", available: true },
      { text: "Custom Source Whitelisting & Advanced Filters", available: true },
      { text: "Live fact-check support for events", available: true },
    ],
  };

  // Helper to Render Features
  const renderFeatures = (features) => (
    <ul className="feature-list">
      {features.map((feature, index) => (
        <li key={index} className="feature-item">
          <span
            className={`feature-icon ${
              feature.available ? 'available' : 'unavailable'
            }`}
          >
            {feature.available ? '✓' : '✗'}
          </span>
          {feature.text}
        </li>
      ))}
    </ul>
  );

  // Handlers for Modal
  const handleSubscribeClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {  // 🔹 Use the correct state reference
      name: formData.name,
      email: formData.email,
      message: formData.message,
      date: new Date().toLocaleString("en-SG", { timeZone: "Asia/Singapore" }) // Get SGT timestamp
    };

    fetch(backendUrl+"/submit-contact-form", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formDataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setSnackbarMessage("Form submitted successfully, thank you for contacting us, we will get back soon!");
          setSnackbarSeverity("success");
          setShowOverlay(false)        
        } else {
          setSnackbarMessage("Something went wrong. Please try again.");
          setSnackbarSeverity("error");
        }
        setSnackbarOpen(true);
      })
      .catch(() => {
        setSnackbarMessage("Error submitting form. Please check your connection.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
    
  };

  const handleCheckout = async () => {
    if (!user?.email) {
      alert("Kindly Sign in before checkout.");
      return;
    }
  
    try {
      const response = await fetch(`${backendUrl}/create-checkout-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_email: user.email }),
      });
  
      const data = await response.json();
      if (data.url) {
        window.location.href = data.url; // Redirect to Stripe Checkout
      } else {
        alert("Error creating checkout session");
      }
    } catch (error) {
      console.error("Checkout error:", error);
    }
  };
  

  return (
    <>
      {/* Header Section */}
      <Grid
        container
        item
        xs={12}
        sx={{
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center the logo
          paddingY: { xs: 1, sm: 2 },
          paddingX: { xs: 1, sm: 2 },
          backgroundColor: 'transparent',
          position: 'relative', // For absolute positioning of child elements
          borderBottom: isMdUp ? '2px solid #0066FF' : '1px solid #0066FF',
        }}
      >
        {/* Central Logo */}
        <a href="https://facticity.ai" style={{ textDecoration: 'none' }}>
          <img
            src="/facticityailogo-02.png"
            alt="Facticity.AI"
            style={{
              paddingTop: isMdUp ? '2px' : '3px',
              width: 'auto',
              height: isMdUp ? '32px' : '26px',
            }}
          />
        </a>

        {/* Left IconButton (Sidebar Toggle) */}
        {/* {isAuthenticated && (
          <IconButton
            onClick={toggleSidebar}
            sx={{ position: 'absolute', left: 15, zIndex: 1000 }}
          >
            <MenuIcon sx={{ color: '#0066FF' }} />
          </IconButton>
        )} */}

        {/* Sidebar Component */}
        {/* {isAuthenticated && (
          <Sidebar
            isOpen={isSidebarOpen}
            handleCloseSidebar={handleCloseSidebar}
            sx={{ marginTop: '60px' }}
            setIsSearchMoved={setIsSearchMoved}
            createConversation={createConversation}
          />
        )} */}

        {/* Right Side: ThirdColumn or Create Conversation Button */}
        {(!isAuthenticated || isMdUp) ? (
          <Box sx={{ position: 'absolute', right: 15 }}>
            <ThirdColumn />
          </Box>
        ) : (
          <div>
            
          </div>
        )}
      </Grid>
      <div className="subscription-container">
  <Box mb={2}>
    <Button
      variant="outlined"
      startIcon={<ArrowBack />}
      onClick={() => navigate('/')}
      align="left"
    >
      Back
    </Button>
  </Box>
  <h1 className="page-title">Choose Your Facticity.AI Plan</h1>

  <div className="plans-wrapper">
    {/* Free Tier */}
    <div className="plan-card free-tier">
      <h2 className="plan-title">{freeTier.title}</h2>
      <p className="plan-price">{freeTier.price}</p>
      <p className="plan-description">{freeTier.description}</p>
      {renderFeatures(freeTier.features)}
      <button className={`plan-button ${isProUser ? "free-button" : "current-plan-button"}`}>
        {isProUser ? "Free" : "Current Plan"}
      </button>
    </div>

    {/* Pro Tier */}
    <div className="plan-card pro-tier">
      <h2 className="plan-title">{proTier.title}</h2>
      <p className="plan-price">{proTier.price}</p>
      <p className="plan-description">{proTier.description}</p>
      {renderFeatures(proTier.features)}
      {isProUser === null ? (
  <div className="loader">Loading...</div>
) : (
  <button
    className={`plan-button ${isProUser ? "manage-button" : "pro-button"}`}
    onClick={() => {
      if (isProUser) {
        // Redirect to Stripe billing management page for Pro users
        window.location.href = "https://billing.stripe.com/p/login/fZe5oh2o32NhdNu3cc";
      } else {
        if (!user?.email) {
          alert("Kindly Sign in before checkout.");
          return;
        }
        else{
        //window.location.href = "https://buy.stripe.com/dR63dwdwX0t25iM28n";
        handleCheckout()
      }
      }
    }}
  >
    {isProUser ? "Manage Subscription" : "Start 7-day free trial"}
  </button>
)}


    </div>

    {/* Enterprise Tier */}
    <div className="plan-card pro-tier">
      <h2 className="plan-title">{entTier.title}</h2>
      <p className="plan-price">{entTier.price}</p>
      <p className="plan-description">{entTier.description}</p> {/* Display Description */}
      {renderFeatures(entTier.features)}
      <button className={`plan-button ${isProUser ? 'manage-button' : 'pro-button'}`} onClick={() => setShowOverlay(true)}>
        Book an Intro
      </button>
    </div>
  </div>

  {/* Overlay for contact */}
  {showOverlay && (
    <div className="overlay">
      <div className="overlay-content">
        <button 
          className="close-button" 
          onClick={() => setShowOverlay(false)}
          style={{
            position: 'absolute',
            top: '15px',
            right: '20px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
            }
          }}
        >
          ×
        </button>
        <p className="contact-text">Email us at <a href="mailto:enquiries@aiseer.co">enquiries@aiseer.co</a></p>
        <hr className="divider" />
        <p className="contact-text">
          Set up a meeting at <a href="https://www.calendly.com/aiseer.co" target="_blank" rel="noopener noreferrer">Calendly</a>
        </p>
        <hr className="divider" />

        {success ? (
          <p className="success-message">Your message has been sent!</p>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <label>Name:</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-row">
              <label>Email:</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-row">
              <label>Message:</label>
              <textarea name="message" value={formData.message} onChange={handleChange} required />
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </form>
        )}
      </div>
    </div>
  )}

  <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
    <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
      {snackbarMessage}
    </Alert>
  </Snackbar>

  {/* Modal */}
  {isModalOpen && (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">Coming Soon</h3>
        <p className="modal-text">
          Our payment gateway is currently being integrated and will be available soon.
        </p>
        <p className="modal-subtext">
          Stay tuned! In the meantime, enjoy your Pro Subscription Free Trial.
        </p>
        <button className="modal-close-button" onClick={handleCloseModal}>Close</button>
      </div>
    </div>
  )}
</div>
    </>
  );
};

export default Subscription;
